const DEV_ALERT = {
  ERROR_BOT_TOKEN: '5616829415:AAGI4ZF5vFGOGdmATKmGtP5OzDHfFe9ucqs',
  ERROR_CHAT_ID: '-1002735711138',
  INFO_BOT_TOKEN: '5616829415:AAGI4ZF5vFGOGdmATKmGtP5OzDHfFe9ucqs',
  INFO_CHAT_ID: '-1002735711138',
}

export { DEV_ALERT }
